var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgVerified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 21,
    height: 21,
    rx: 2.8,
    fill: "#1D9BF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.858,
    y: -0.7,
    width: 21,
    height: 21,
    rx: 2.8,
    transform: "rotate(45 13.858 -.7)",
    fill: "#1D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.756 14.438l3.267 3.267 6.533-6.534",
    stroke: "#fff",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMy41IiB5PSIzLjUiIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgcng9IjIuOCIgZmlsbD0iIzFEOUJGMCIvPgo8cmVjdCB4PSIxMy44NTc5IiB5PSItMC42OTk5OTciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgcng9IjIuOCIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTMuODU3OSAtMC42OTk5OTcpIiBmaWxsPSIjMUQ5QkYwIi8+CjxwYXRoIGQ9Ik05Ljc1NjM1IDE0LjQzOEwxMy4wMjMgMTcuNzA0NkwxOS41NTYzIDExLjE3MTMiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMi4xIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgOrgVerified as ReactComponent };